import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { patchFinanceAccount } from "../../utils/apiClient";
import { accountMenuLabel } from "./AccountSelect";

function draftFromAccounts(accounts) {
  const next = {};
  (accounts || []).forEach((account) => {
    next[account.account_uuid] =
      account.monthly_expense_budget != null ? String(account.monthly_expense_budget) : "";
  });
  return next;
}

export default function FinanceBudgetPanel({ accounts = [], onAccountsChange, onError, formatMoney }) {
  const [drafts, setDrafts] = useState(() => draftFromAccounts(accounts));

  useEffect(() => {
    setDrafts(draftFromAccounts(accounts));
  }, [accounts]);

  const saveBudget = async (account) => {
    const raw = (drafts[account.account_uuid] || "").trim().replace(",", ".");
    const next = raw === "" ? null : Number(raw);
    if (next != null && !Number.isFinite(next)) {
      onError("Ugyldigt beløb");
      return;
    }
    const current = account.monthly_expense_budget == null ? null : Number(account.monthly_expense_budget);
    if (next === current || (next == null && current == null)) return;
    onError("");
    try {
      const updated = await patchFinanceAccount(account.account_uuid, {
        monthly_expense_budget: next,
      });
      onAccountsChange(
        accounts.map((item) => (item.account_uuid === updated.account_uuid ? updated : item))
      );
    } catch (err) {
      const detail = err.response?.data?.detail;
      onError(typeof detail === "string" ? detail : err.message || "Kunne ikke gemme budget");
    }
  };

  if (!accounts.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        Ingen konti endnu. Forbind en konto under Profil → Bank.
      </Typography>
    );
  }

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Sæt et månedligt udgiftsbudget per konto. Overblik viser forbruget op mod budgettet, når du kigger på én konto.
        Måneden følger indstillingen under Profil → Bank (kalender eller sidste bankdag).
      </Typography>
      <Stack spacing={2} sx={{ maxWidth: 480 }}>
        {accounts.map((account) => (
          <TextField
            key={account.account_uuid}
            size="small"
            type="number"
            label={accountMenuLabel(account)}
            value={drafts[account.account_uuid] ?? ""}
            onChange={(event) =>
              setDrafts((prev) => ({ ...prev, [account.account_uuid]: event.target.value }))
            }
            onBlur={() => saveBudget(account)}
            inputProps={{ min: 0, step: "1" }}
            helperText={
              account.monthly_expense_budget != null
                ? `Gemt: ${formatMoney(account.monthly_expense_budget, account.currency)} / måned`
                : "Intet budget"
            }
          />
        ))}
      </Stack>
    </Box>
  );
}
